import { render, staticRenderFns } from "./webFooter.vue?vue&type=template&id=40d9c650&scoped=true&"
import script from "./webFooter.vue?vue&type=script&lang=js&"
export * from "./webFooter.vue?vue&type=script&lang=js&"
import style0 from "./webFooter.vue?vue&type=style&index=0&id=40d9c650&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9c650",
  null
  
)

export default component.exports